const apiPaths = {
  account: "auth/edit",
};

const apiRoute = (path: string) => `${import.meta.env.VITE_OAUTH}${path}`;

export { apiPaths, apiRoute };
